var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMutedinline = function SvgMutedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.7502 10.0138V5.32461C10.7502 2.70361 10.7502 1.39311 9.97916 1.06698C9.20808 0.740838 8.3005 1.6675 6.48551 3.52083C5.54557 4.4806 5.00929 4.69314 3.67195 4.69314C2.50239 4.69314 1.91761 4.69314 1.49754 4.97975C0.625539 5.57469 0.757347 6.73756 0.757347 7.66923C0.757347 8.6009 0.625539 9.76373 1.49754 10.3587C1.91761 10.6453 2.50239 10.6453 3.67195 10.6453C5.00929 10.6453 5.54557 10.8579 6.48551 11.8176C8.3005 13.671 9.20808 14.5976 9.97916 14.2715C10.7502 13.9453 10.7502 12.6348 10.7502 10.0138Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M13.417 6.00256L16.7503 9.3359M13.417 9.3359L16.7503 6.00256"
  })));
};
export default SvgMutedinline;